import React, { Component } from "react";
import { connect } from "react-redux";
import { StoragesSystem } from "../../../@main-module/actions-manager/actions-data";
import { withRouter } from "../../../@hoc/with-router";
import { RenderNodes } from "../../../@render-node";
import dataBody from '../json/body.json'
import dataSections from '../json/sections.json'
import fonts from '../json/font.json'
import galery from '../json/galery.json'
import { FontHeader } from "../../../@font-header";
import '../scss/style.scss'
import { Helmet } from "react-helmet";

const PageDefaultProps = {
  StoragesSystem: {
    catalog: []
  }
};

const FILTERS_KEY = {
  catalog: ["navbar","header","stats","feature","theme","pricing","testimony","cta","faq","footer"],
  feature: ["navbar","feature","faq","footer"],
  theme: ["navbar","theme","faq","footer"],
  price: ["navbar","pricing","faq","footer"],
  portfolio: ["navbar","stats", "testimony","cta","faq","footer"],
  privacy: ["navbar","faq","footer"],
  "terms-conditions": ["navbar","faq","footer"],
}

class RenderPage extends Component {
  static defaultProps = PageDefaultProps;
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  timeOut = null;
  componentDidMount = () => {
    document.querySelector('body').className = dataBody.className
  }

  getRenderData = (sections, filters = []) => {
    if(filters.length > 0){
      const filtersObj = {};
      for (let i = 0; i < filters.length; i++) {
        filtersObj[filters[i]] = filters[i]
      }
      for (const key in sections) {
        const item = sections[key];
        const sectionKey = item?.media?.["fox-section"];
        if(filtersObj[sectionKey]){
          // data.sections[key].node = []
        }else{
          item.node = []
        }
      }
      return sections
    }
    return sections
  }
  getSectionFilters = () => {
    const key = this.props.params.page;
    const filters = FILTERS_KEY[key] || [];
    return filters
  }
  render() {
    const { props, state } = this;

    let filters  = this.getSectionFilters();
    let renderSections  = this.getRenderData(dataSections, filters);
    const key = props.params.page || "Undangan online";
    return (
      <div>
        {fonts.length > 0 && 
          <FontHeader fonts = {fonts} /> 
        }
        <Helmet>
          <title>Ulamulem {key}</title>
        </Helmet>
        <RenderNodes {...props} song = {"/images/song.mp3"} databaseId = {"1lc2iOkhu8r7iukqJa43xId_abifdN5mtJUnGpygkd_w"} data = {dataBody} sections = {renderSections} galery = {galery}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  StoragesSystem: state.StoragesSystem,
});
const mapDispatchToProps = (dispatch) => ({
  setStorage: (data = { data: null, type: 'yourkey' }) =>
    dispatch(new StoragesSystem().setStorage(data)),
});

export default  connect(mapStateToProps, mapDispatchToProps)(withRouter(RenderPage, {
    isRestriected: true,
}));
